import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryClientColumn } from '../constants/dictionary-client-columns.constant';
import { authHandle } from './auth.handle';

export const generateClientColumns = () => {
	return [
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].name,
			dataIndex: 'first_name',
			key: 'first_name',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].lastname,
			dataIndex: 'last_name',
			key: 'last_name',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].document,
			dataIndex: 'rut',
			key: 'rut',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].email,
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].phone,
			dataIndex: 'phone',
			key: 'phone',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].gender,
			dataIndex: 'sex',
			key: 'sex',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].status,
			dataIndex: 'auth',
			key: 'auth',
			render: (auth) => authHandle(auth),
		},
	];
};
